import { IDataRepo } from 'common/contracts';

export const ElectricalSwitchRoomRepo: IDataRepo[] = [
  {
    id: 'dataCenter/electricalSwitchRoom/AutroSense',
    label: 'AutroSense',
    position: {
      top: 56,
      left: 15,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/electricalSwitchRoom/Sounder',
    label: 'Sounder',
    position: {
      top: 40,
      left: 67,
      unit: '%'
    }
  }
];
